import type { APIs } from './index';
import { cancel } from './cancel';
import getQr from './getQr';
import { getMerchantDetails } from './merchant';
import { pollStatus } from './status';
import { submitPhoneNumber } from './submit';
import validateClaims from './validateClaims';

export const standardAPIs: APIs = {
  validateClaims: validateClaims,
  pollStatus: pollStatus,
  submitNumber: submitPhoneNumber,
  cancel: cancel,
  getQr: getQr,
  getMerchantDetails: getMerchantDetails,
};
